import CardAuctionPage from './CardAuctionPage';

export default CardAuctionPage;
